// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "b67ebacc7ff8c156" + ".css";
};